var Module = {
    name: 'LocationDetector',
    init() {
        // Check is meta available and location already detected by meta
        const meta = $('meta[name="location_country"]');
        if (!meta.length || meta.attr('content').length) {
            return;
        }

        $.get($('meta[name="app-url"]').attr('content') + '/ajax/detect-user-country', response => {
            if (response?.country?.length) {
                $(document).trigger('LocationDetector:detected', response.country);
            }
        });
    }
}

module.exports = Module
